// #region Dependencias
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledList = styled.ul`
  max-height: 550px;
  flex-wrap: wrap;
  justify-content: space-between;
  list-style: none;
  padding: 0;
`
// #endregion

/**
 * Componente que renderiza un contenedor de lista <ul />.
 *
 * @class
 * @example <List>...</List>
 * @param {Object} props - Propiedades del componente.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const List = ({ children, ...props }) => {
  return <StyledList {...props}>{children}</StyledList>
}

export default List
